import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getUsageData = async (foiList = [], apiToken = null) => {
    //console.log("CALLING SERVER with getresourceusagelist")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getresourceusagelist",
            "formstateidArray": foiList,
            "apiToken": apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'usageDataDictionary': usageDataDictionary }
            if (resp.data.success && resp.data.usageDataDictionary) {
                //console.log("SUCCESSFUL RESPONSE from getresourceusagelist call")
                //usageDataDictionary contains { totalviews: 0, totaledits: 0, totalusersviewed: 0, totalusersedited: 0, 
                // editpermission: boolean, readpermission: boolean, adminpermission: boolean, 
                // invitecode: string, editors: array of {id, name}, status: string }
                return resp.data.usageDataDictionary;
            } else {
                console.log("FAILED RESPONSE from getresourceusagelist call")
                return null;
            }
        }
        console.log("NO RESPONSE from getresourceusagelist call");
    }).catch((error) => { console.log(error); });
};

export default getUsageData;